import React, {useEffect, useState} from 'react'
import axios from 'axios'
import TableCoins from './components/TableCoins'
import Pagination from './components/Pagination'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

function App() {

  const [coins, setCoins] = useState([]);
  const [search, setSearch] = useState('');
  const [darkmode, setDarkMode] = useState( false );
  const [currentPage, setCurrentPage] = useState( 1 );

  const getData = async ( page ) => {
    page = page ? page : currentPage;
    const apiKey = 'CG-grxSESFgyZyCTDhGw8Bvsjtf'; // API Demo Key
    const res = await axios.get( 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc' +
        '&per_page=30&page=' + page + '&x_cg_demo_api_key=' + apiKey );
    setCoins(res.data);
  };

  const changeCurrentPage = ( page ) => {
    if ( page >= 1 ) {
      setCurrentPage( page );
      getData( page )
    }
  }

  const changeDarkMode = () => {
    
    let curr_darkmode = ! darkmode;
    setDarkMode( curr_darkmode );

    switch ( curr_darkmode ) {
      case true:
        document.body.classList.add('dark-mode');
        break;
      case false:
      default:
        document.body.classList.remove('dark-mode');
        break;
    }

  };

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className={`app-container ${darkmode ? 'dark-mode' : ''}`}>
      <div className="container-fluid px-4 py-5">
        <div className="header-section mb-5">
          <div className="title-wrapper text-center mb-4">
            <h1 className="main-title">
              <span className="title-main">Coin Market Info</span>
              <span className="title-subtitle">All the info about crypto</span>
            </h1>
          </div>
          
          <div className='header-controls'>
            <div className="search-wrapper">
              <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input 
                type="text" 
                placeholder='Search a coin...' 
                className={`search-input ${darkmode ? 'dark' : 'light'}`} 
                onChange={e => setSearch(e.target.value)} 
              />
            </div>
            
            <div className="dark-mode-toggle">
              <label className="toggle-label">
                <span className="toggle-text">Dark Mode</span>
                <input 
                  type="checkbox" 
                  className='dark-mode-checkbox' 
                  checked={darkmode}
                  onChange={e => changeDarkMode()}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="table-wrapper">
          <TableCoins coins={coins} search={search} darkmode={darkmode} />
        </div>

        <div className="pagination-wrapper mt-5">
          <Pagination currentPage={currentPage} changeCurrentPage={changeCurrentPage} darkmode={darkmode} />
        </div>
      </div>
    </div>
  );
}

export default App;
